import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InnerHeader from './InnerHeader';
import decryptedUserId from '../Utils/UserID';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { LibraryBooks } from '@mui/icons-material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
//import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { StyledDataGrid } from './StyledDataGrid';
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import YearlyReport from './Document/YearlyReport';
import { pdf } from '@react-pdf/renderer';
import Mock_Report from './Document/Mock_Report';

const YearlyMock = () => {

    const [course, setCourse] = useState([])
    const [mockdata, setMockdata] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState({});
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });



    const [value, setValue] = useState({
        Course_Id: '',
        year: '',
        fromyear: ''
    })

    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }



    useEffect(() => {
        getCourseData()
    }, [])

    const onhandleChange = (e) => {
        const { name, value } = e.target;

        // Update form value
        setValue((prev) => {
            let updated = { ...prev, [name]: value };

            // If "year" dropdown is changed, update "fromyear" to year + 1
            if (name === 'year') {
                const nextYear = parseInt(value) + 1;
                if (!isNaN(nextYear)) {
                    updated.fromyear = nextYear.toString();
                }
            }

            return updated;
        });
    };



    const roledata = {
        role: Cookies.get(`role`),
        pageid: 54,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);


    const handlegetpdf = async () => {
        try {

            if(mockdata.length == 0 ){
              alert("No data found")  
              return false;
            }
            
            const blob = await pdf(<Mock_Report reportData={mockdata} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.log("Error", err)
        }

    }


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!value.Course_Id) {
            isValid = false;
            newErrors.Course_Id = "Course is Required";
        }
        if (!value.year) {
            isValid = false;
            newErrors.year = "Year is Required";
        }

        setError(newErrors);
        return isValid;
    };

    const handlesubmit = (e) => {
        e.preventDefault()

        if (validateForm()) {
            const data = {
                course_id: value.Course_Id,
                year: value.year,
                fromyear: value.fromyear
            }

            axios.post(`${BASE_URL}/getyearlymockdata`, data)
                .then((res) => {
                    console.log(res.data)
                    setMockdata(res.data.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }


    }


    const columns = [
        {
            field: 'index',
            headerName: 'Id',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,

        },
        { field: 'Course_Name', headerName: 'Course Name', flex: 2 },
        { field: 'Batch_code', headerName: 'Batch code', flex: 2 },
        { field: 'month', headerName: 'Month', flex: 2 },
        {
    field: 'Take_Dt',
    headerName: 'Date',
    flex: 2,
    renderCell: (params) => {
        if (!params.value) return "";

        // If already in DD-MM-YYYY format
        const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
        if (ddmmyyyyRegex.test(params.value)) {
            return params.value;
        }

        // If API returns yyyymmdd format
        if (/^\d{8}$/.test(params.value)) {
            const year = params.value.substring(0, 4);
            const month = params.value.substring(4, 6);
            const day = params.value.substring(6, 8);
            return `${day}-${month}-${year}`;
        }

        // Try parsing yyyy-mm-dd or Date object
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return "";

        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    }
}

    ];


    const rowsWithIds = mockdata.map((row, index) => ({ index: index + 1, ...row }));

    return (

        <div class="container-fluid page-body-wrapper">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Yearly Mock Interview</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3" onSubmit={handlesubmit}>
                                        <div class='row'>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.Course_Id} name='Course_Id' onChange={onhandleChange}>
                                                    <option>Select Course</option>
                                                    {(Array.isArray(course) ? course : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>

                                                        )
                                                    })}
                                                </select>
                                                {error.Course_Id && <span className='text-danger'>{error.Course_Id}</span>}
                                            </div>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Year<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.year} onChange={onhandleChange} name='year'>
                                                    <option value="">Select Year</option>
                                                    <option>2026</option>
                                                    <option>2025</option>
                                                    <option>2024</option>
                                                    <option>2023</option>
                                                    <option>2022</option>
                                                    <option>2021</option>
                                                    <option>2020</option>
                                                    <option>2019</option>
                                                    <option>2018</option>
                                                    <option>2017</option>
                                                    <option>2016</option>
                                                    <option>2015</option>
                                                    <option>2014</option>
                                                    <option>2013</option>
                                                    <option>2012</option>
                                                    <option>2011</option>
                                                    <option>2010</option>
                                                    <option>2009</option>
                                                    <option>2008</option>
                                                    <option>2007</option>
                                                    <option>2006</option>
                                                    <option>2005</option>
                                                    <option>2004</option>
                                                    <option>2003</option>
                                                    <option>2002</option>
                                                </select>
                                                {error.year && <span className='text-danger'>{error.year}</span>}
                                            </div>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleInputUsername1"></label>
                                                <input type="text" class="form-control" id="exampleInputUsername1" value={value.fromyear} placeholder="From Year" name='fromyear' onChange={onhandleChange} />
                                            </div>
                                            <div class="form-group col-lg-12">
                                                <button type="submit" class="btn btn-primary mr-2">Go</button>
                                            </div>

                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                        {mockdata.length > 0 && <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div className='d-flex justify-content-between' style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                        <div>
                                            <h4 class="card-title">Yearly Mock Interview Report</h4>
                                        </div>

                                    </div>

                                    <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                        <StyledDataGrid
                                            rows={rowsWithIds}
                                            columns={columns}
                                            // disableColumnFilter
                                            disableColumnSelector
                                            disableDensitySelector
                                            rowHeight={35}
                                            getRowId={(row) => row.Take_Id}
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            pageSizeOptions={[50]}
                                            autoHeight={false}
                                            sx={{
                                                height: 500, // Ensure enough height for pagination controls
                                                '& .MuiDataGrid-footerContainer': {
                                                    justifyContent: 'flex-end',
                                                },
                                            }}
                                            slots={{
                                                toolbar: GridToolbar
                                            }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />


                                    </div>

                                    <button type="button" class="btn btn-primary mr-2" onClick={handlegetpdf}>Print</button>
                                    <button type='button' onClick={() => {
                                        window.location.reload()
                                    }} class="btn btn-primary mr-2">Back</button>


                                </div>
                            </div>
                        </div>}

                    </div>
                </div>
            </div >
        </div >

    )
}

export default YearlyMock
